import React, { Component } from 'react';
import { connect } from "react-redux";
import {Link, useParams} from "react-router-dom";
@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})


class ReportsSidebar extends Component {

    constructor(props) {
        super(props);
        var reportItems = [
            { key:"general", icon: "bx bx-chart", hasSub: false, clicked:false, title: "General Reports" },
			{ key:"hourly", icon: "bx bx-chart", hasSub: false, clicked:false, title: "Hourly Reports" }
        ];
        this.state = {
            reportItems: reportItems
        };
        this.handleOnClick=this.handleOnClick.bind(this);


    }

    handleOnClick(key){
        const { reportItems } = this.state;

        const updatedItems = reportItems.map(item => {

                if (item.key == key) {

                    return {
                        ...item,
                        clicked: !item.clicked
                    };
                }else{
                    return {
                        ...item,
                        clicked: false
                    };
                }

        });

        this.setState({
            reportItems: updatedItems
        });

    }

    render() {
        const { t } = this.props;
        const { reportItems } = this.state;
        return (
            <div id="chat_left_sidebar_id">
                <div className="sidebar-group left-sidebar chat_sidebar settings">
                    <div id="chats" className="left-sidebar-wrap sidebar active">
                        <div className="sidebar-header">
                            <div className="sidebar-header-flex">
                                <div className="sidebar-header-title">
                                    Reports
                                </div>
                            </div>
                        </div>

                        <div className="settings">
                            <ul>
                                {reportItems.map(item => {
                                    var clicked=false;
                                    if(typeof item.sub_items !== "undefined"){
                                        item.sub_items.map(subitem => {
                                            if(this.props.match.params.link==subitem.link){
                                                clicked=true;
                                            }
                                        });
                                    }
                                       return(
                                           <li  className={"menu-item "+(item.hasSub===true ? "has-sub": "")+(item.hasSub===true && (item.clicked===true || clicked==true) ? " active": "")}>

                                               {item.hasSub===true &&
                                                 <Link to="" onClick={() => this.handleOnClick(item.key)} className={"menu-link "+(item.hasSub===true ? "menu-toggle": "")} >
                                                     <span className="menu-icon"><em className={"icon menuIcon "+item.icon}></em></span>
                                                     <span className="menu-text">{item.title}</span>
                                                 </Link>
                                                }
                                               {item.hasSub===false &&
                                                   <Link to={"/reports/"+item.key}  className={"menu-link "+(item.hasSub===true ? "menu-toggle": "")} >
                                                       <span className="menu-icon"><em className={"icon "+item.icon}></em></span>
                                                       <span className="menu-text">{item.title}</span>
                                                   </Link>
                                               }



                                               {item.hasSub === true &&
                                               <div className="menu-wrap" style={{
                                                   "height": (clicked===true || item.clicked==true ? "auto" : "0px")
                                               }}
                                                   >
                                                   {typeof item.sub_items !== "undefined" &&
                                                   <ul className="menu-sub">
                                                       {item.sub_items.map(subitem => {
                                                          return  <li className="menu-item">
                                                                      <Link to={"/reports/"+subitem.link} className={"menu-link "+(this.props.match.params.link==subitem.link ? "active" : "")}>
                                                                         <span
                                                                           className="menu-text">{subitem.name}
                                                                         </span>
                                                                      </Link>
                                                                  </li>

                                                       })}
                                                   </ul>
                                                   }

                                               </div>
                                               }
                                           </li>
                                       )
                                })}

                            </ul>
                        </div>



                    </div>
                </div>
            </div>
        );
    }
}
export function withRouter(Children){
    return(props)=>{

        const match  = {params: useParams()};
        return <Children {...props}  match = {match}/>
    }
}
export default withRouter(ReportsSidebar, { withRef: true });

